// Composed URLS object — same shape as legacy ConstantVariables.ts
import { Company } from './controllers/Company';
import { Main } from './controllers/Main';
import { Roles } from './controllers/Roles';
import { BlobStorage } from './controllers/BlobStorage';
import { Rights } from './controllers/Rights';
import { State } from './controllers/State';
import { User } from './controllers/User';
import { InviteUser } from './controllers/InviteUser';
import { Applicant } from './controllers/Applicant';
import { BenefitLifeEvent } from './controllers/BenefitLifeEvent';
import { EmployeeBenefitLifeEvent } from './controllers/EmployeeBenefitLifeEvent';
import { Employee } from './controllers/Employee';
import { EmployeeFormRequest } from './controllers/EmployeeFormRequest';
import { Twilio } from './controllers/Twilio';
import { Outlook } from './controllers/Outlook';
import { QuickBook } from './controllers/QuickBook';
import { ClientBadges } from './controllers/ClientBadges';
import { ClientBenefitsPlan } from './controllers/ClientBenefitsPlan';
import { ClientBenefitsGroup } from './controllers/ClientBenefitsGroup';
import { ClientHolidaysCalender } from './controllers/ClientHolidaysCalender';
import { EmployeeSkill } from './controllers/EmployeeSkill';
import { JobSkill } from './controllers/JobSkill';
import { EmployeeEducation } from './controllers/EmployeeEducation';
import { ClientApprovedWcCode } from './controllers/ClientApprovedWcCode';
import { EmployeeExperience } from './controllers/EmployeeExperience';
import { EmployeeLicenseCertificate } from './controllers/EmployeeLicenseCertificate';
import { EmployeeSocialMedia } from './controllers/EmployeeSocialMedia';
import { EmployeeStatus } from './controllers/EmployeeStatus';
import { ClientProfile } from './controllers/ClientProfile';
import { ClientPayrollPayGroup } from './controllers/ClientPayrollPayGroup';
import { Common } from './controllers/Common';
import { EmployeeBadges } from './controllers/EmployeeBadges';
import { ClientSetting } from './controllers/ClientSetting';
import { ClientCategory } from './controllers/ClientCategory';
import { BusinessEntity } from './controllers/BusinessEntity';
import { BillingTemplate } from './controllers/BillingTemplate';
import { CompanyOnboardingStatus } from './controllers/CompanyOnboardingStatus';
import { Client } from './controllers/Client';
import { ClientWcBillingStateRule } from './controllers/ClientWcBillingStateRule';
import { ClientOnboarding } from './controllers/ClientOnboarding';
import { EmployeeTypes } from './controllers/EmployeeTypes';
import { ClientEmployees } from './controllers/ClientEmployees';
import { ClientPayrollPayDay } from './controllers/ClientPayrollPayDay';
import { ClientPayrollConfiguration } from './controllers/ClientPayrollConfiguration';
import { CareerPageSetting } from './controllers/CareerPageSetting';
import { CareerPage } from './controllers/CareerPage';
import { ClientNote } from './controllers/ClientNote';
import { ClientGuests } from './controllers/ClientGuests';
import { ClientPayrollTaxOverride } from './controllers/ClientPayrollTaxOverride';
import { ClientInvoice } from './controllers/ClientInvoice';
import { Monster } from './controllers/Monster';
import { ClientContact } from './controllers/ClientContact';
import { ClientContactNotes } from './controllers/ClientContactNotes';
import { ClientAttachment } from './controllers/ClientAttachment';
import { ClientBranch } from './controllers/ClientBranch';
import { ClientGuestAttachment } from './controllers/ClientGuestAttachment';
import { Candidate } from './controllers/Candidate';
import { Email } from './controllers/Email';
import { CandidateSkill } from './controllers/CandidateSkill';
import { CandidateExperience } from './controllers/CandidateExperience';
import { CandidateResume } from './controllers/CandidateResume';
import { CandidateAttachment } from './controllers/CandidateAttachment';
import { CandidateTask } from './controllers/CandidateTask';
import { ClientTask } from './controllers/ClientTask';
import { EmployeeTask } from './controllers/EmployeeTask';
import { EmployeeTaxSetting } from './controllers/EmployeeTaxSetting';
import { ClientContactTask } from './controllers/ClientContactTask';
import { JobTask } from './controllers/JobTask';
import { CandidateNotes } from './controllers/CandidateNotes';
import { CandidateJob } from './controllers/CandidateJob';
import { CandidateSocialMedia } from './controllers/CandidateSocialMedia';
import { Job } from './controllers/Job';
import { JobRecommendation } from './controllers/JobRecommendation';
import { CandidateRecommendation } from './controllers/CandidateRecommendation';
import { CandidateStatus } from './controllers/CandidateStatus';
import { JobStatus } from './controllers/JobStatus';
import { JobBadges } from './controllers/JobBadges';
import { CandidateBadges } from './controllers/CandidateBadges';
import { ManageTeams } from './controllers/ManageTeams';
import { JobNotes } from './controllers/JobNotes';
import { CandidateEducation } from './controllers/CandidateEducation';
import { JobRequest } from './controllers/JobRequest';
import { JobRequestStatuses } from './controllers/JobRequestStatuses';
import { JobAttachment } from './controllers/JobAttachment';
import { ClientContactAttachment } from './controllers/ClientContactAttachment';
import { EmployeeAttachment } from './controllers/EmployeeAttachment';
import { EmployeeEnrollment } from './controllers/EmployeeEnrollment';
import { EmployeeNotes } from './controllers/EmployeeNotes';
import { EmployeeBankDetails } from './controllers/EmployeeBankDetails';
import { PaycheckCalculator } from './controllers/PaycheckCalculator';
import { ClientGuestNotes } from './controllers/ClientGuestNotes';
import { ClientGuestTask } from './controllers/ClientGuestTask';
import { BillingCode } from './controllers/BillingCode';
import { BillingEvent } from './controllers/BillingEvent';
import { ApplicationForms } from './controllers/ApplicationForms';
import { SwipeClock } from './controllers/SwipeClock';
import { Departments } from './controllers/Departments';
import { Designation } from './controllers/Designation';
import { CandidateInterview } from './controllers/CandidateInterview';
import { InterviewRemarks } from './controllers/InterviewRemarks';
import { JobPublishSetting } from './controllers/JobPublishSetting';
import { ClientAssessments } from './controllers/ClientAssessments';
import { SovrenResumeParsing } from './controllers/SovrenResumeParsing';
import { TimeSheet } from './controllers/TimeSheet';
import { PtoTimeoffSetup } from './controllers/PtoTimeoffSetup';
import { SubscriptionPlans } from './controllers/SubscriptionPlans';
import { OfferLetter } from './controllers/OfferLetter';
import { PayrollPayCode } from './controllers/PayrollPayCode';
import { PayrollPtoPolicy } from './controllers/PayrollPtoPolicy';
import { PayrollDeductionCode } from './controllers/PayrollDeductionCode';
import { SentOfferLetter } from './controllers/SentOfferLetter';
import { PayrollSicCodeSetup } from './controllers/PayrollSicCodeSetup';
import { PayrollNaicsCodeSetup } from './controllers/PayrollNaicsCodeSetup';
import { PayrollProcessingSchedule } from './controllers/PayrollProcessingSchedule';
import { StateMinWageRate } from './controllers/StateMinWageRate';
import { PayrollSutaSetup } from './controllers/PayrollSutaSetup';
import { PayrollWcPolicies } from './controllers/PayrollWcPolicies';
import { PayrollCostCenter } from './controllers/PayrollCostCenter';
import { PayrollDeliveryMethod } from './controllers/PayrollDeliveryMethod';
import { BenefitsPlan } from './controllers/BenefitsPlan';
import { ClientBenefitsEnrollment } from './controllers/ClientBenefitsEnrollment';
import { PayrollWCClassification } from './controllers/PayrollWCClassification';
import { PayrollSchedule } from './controllers/PayrollSchedule';
import { OnboardingBenefitGroup } from './controllers/OnboardingBenefitGroup';
import { PayrollWCRates } from './controllers/PayrollWCRates';
import { Dashboard } from './controllers/Dashboard';
import { PtoClassCodes } from './controllers/PtoClassCodes';
import { Reports } from './controllers/Reports';
import { Payroll } from './controllers/Payroll';
import { RunPayroll } from './controllers/RunPayroll';
import { PayrollReview } from './controllers/PayrollReview';
import { PayrollHistory } from './controllers/PayrollHistory';
import { PayrollACH } from './controllers/PayrollACH';
import { Benefits } from './controllers/Benefits';
import { GlobalSearch } from './controllers/GlobalSearch';
import { BillingRule } from './controllers/BillingRule';
import { JobCustomTemplate } from './controllers/JobCustomTemplate';
import { BenefitsContribution } from './controllers/BenefitsContribution';
import { CrimCheck } from './controllers/CrimCheck';
import { ReferenceCheck } from './controllers/ReferenceCheck';
import { ReferenceCheckRequest } from './controllers/ReferenceCheckRequest';
import { TrainingManagement } from './controllers/TrainingManagement';
import { NewHirePacketSettings } from './controllers/NewHirePacketSettings';
import { EmployeeOnboarding } from './controllers/EmployeeOnboarding';
import { W2FormCustomSection } from './controllers/W2FormCustomSection';
import { SettingsServiceType } from './controllers/SettingsServiceType';
import { EEOClassCode } from './controllers/EEOClassCode';
import { BillingFormat } from './controllers/BillingFormat';
import { EEOPositionGroup } from './controllers/EEOPositionGroup';
import { Position } from './controllers/Position';
import { PositionRate } from './controllers/PositionRate';
import { BankAccount } from './controllers/BankAccount';
import { AbaBankRouting } from './controllers/AbaBankRouting';
import { EeoPositionClassification } from './controllers/EeoPositionClassification';
import { ReasonCodeSetup } from './controllers/ReasonCodeSetup';
import { Payee } from './controllers/Payee';
import { GarnishmentStateRule } from './controllers/GarnishmentStateRule';
import { CompanyGroup } from './controllers/CompanyGroup';
import { CompanyBranch } from './controllers/CompanyBranch';
import { Garnishment } from './controllers/Garnishment';
import { ClientBillingRateOverrides } from './controllers/ClientBillingRateOverrides';
import { GarnishmentCategory } from './controllers/GarnishmentCategory';
import { Summary } from './controllers/Summary';
import { Document } from './controllers/Document';
import { Paystub } from './controllers/Paystub';
import { PTOTimeOff } from './controllers/PTOTimeOff';
import { EmployeeBank } from './controllers/EmployeeBank';
import { EmployeeExtension } from './controllers/EmployeeExtension';
import { Alerts } from './controllers/Alerts';
import { CreateAccount } from './controllers/CreateAccount';
import { PrenoteConfiguration } from './controllers/PrenoteConfiguration';

export const URLS = {
  enwageRedirectUrl: 'http://devenwage.9ostech.com',

  login: 'connect/token',
  Controller: {
    Company,
    Main,
    Roles,
    BlobStorage,
    Rights,
    State,
    User,
    InviteUser,
    Applicant,
    BenefitLifeEvent,
    EmployeeBenefitLifeEvent,
    Employee,
    EmployeeFormRequest,
    Twilio,
    Outlook,
    QuickBook,
    ClientBadges,
    ClientBenefitsPlan,
    ClientBenefitsGroup,
    ClientHolidaysCalender,
    EmployeeSkill,
    JobSkill,
    EmployeeEducation,
    ClientApprovedWcCode,
    EmployeeExperience,
    EmployeeLicenseCertificate,
    EmployeeSocialMedia,
    EmployeeStatus,
    ClientProfile,
    ClientPayrollPayGroup,
    Common,
    EmployeeBadges,
    ClientSetting,
    ClientCategory,
    BusinessEntity,
    BillingTemplate,
    CompanyOnboardingStatus,
    Client,
    ClientWcBillingStateRule,
    ClientOnboarding,
    EmployeeTypes,
    ClientEmployees,
    ClientPayrollPayDay,
    ClientPayrollConfiguration,
    CareerPageSetting,
    CareerPage,
    ClientNote,
    ClientGuests,
    ClientPayrollTaxOverride,
    ClientInvoice,
    Monster,
    ClientContact,
    ClientContactNotes,
    ClientAttachment,
    ClientBranch,
    ClientGuestAttachment,
    Candidate,
    Email,
    CandidateSkill,
    CandidateExperience,
    CandidateResume,
    CandidateAttachment,
    CandidateTask,
    ClientTask,
    EmployeeTask,
    EmployeeTaxSetting,
    ClientContactTask,
    JobTask,
    CandidateNotes,
    CandidateJob,
    CandidateSocialMedia,
    Job,
    JobRecommendation,
    CandidateRecommendation,
    CandidateStatus,
    JobStatus,
    JobBadges,
    CandidateBadges,
    ManageTeams,
    JobNotes,
    CandidateEducation,
    JobRequest,
    JobRequestStatuses,
    JobAttachment,
    ClientContactAttachment,
    EmployeeAttachment,
    EmployeeEnrollment,
    EmployeeNotes,
    EmployeeBankDetails,
    PaycheckCalculator,
    ClientGuestNotes,
    ClientGuestTask,
    BillingCode,
    BillingEvent,
    ApplicationForms,
    SwipeClock,
    Departments,
    Designation,
    CandidateInterview,
    InterviewRemarks,
    JobPublishSetting,
    ClientAssessments,
    SovrenResumeParsing,
    TimeSheet,
    PtoTimeoffSetup,
    SubscriptionPlans,
    OfferLetter,
    PayrollPayCode,
    PayrollPtoPolicy,
    PayrollDeductionCode,
    SentOfferLetter,
    PayrollSicCodeSetup,
    PayrollNaicsCodeSetup,
    PayrollProcessingSchedule,
    StateMinWageRate,
    PayrollSutaSetup,
    PayrollWcPolicies,
    PayrollCostCenter,
    PayrollDeliveryMethod,
    BenefitsPlan,
    ClientBenefitsEnrollment,
    PayrollWCClassification,
    PayrollSchedule,
    OnboardingBenefitGroup,
    PayrollWCRates,
    Dashboard,
    PtoClassCodes,
    Reports,
    Payroll,
    RunPayroll,
    PayrollReview,
    PayrollHistory,
    PayrollACH,
    Benefits,
    GlobalSearch,
    BillingRule,
    JobCustomTemplate,
    BenefitsContribution,
    CrimCheck,
    ReferenceCheck,
    ReferenceCheckRequest,
    TrainingManagement,
    NewHirePacketSettings,
    EmployeeOnboarding,
    W2FormCustomSection,
    SettingsServiceType,
    EEOClassCode,
    BillingFormat,
    EEOPositionGroup,
    Position,
    PositionRate,
    BankAccount,
    AbaBankRouting,
    EeoPositionClassification,
    ReasonCodeSetup,
    Payee,
    GarnishmentStateRule,
    CompanyGroup,
    CompanyBranch,
    Garnishment,
    ClientBillingRateOverrides,
    GarnishmentCategory,
    Summary,
    Document,
    Paystub,
    PTOTimeOff,
    EmployeeBank,
    EmployeeExtension,
    Alerts,
    CreateAccount,
    PrenoteConfiguration,
  },
};
